module.exports = __webpack_public_path__ + "img/book17.34bfadcc.jpg";